<script>
  import {
    Button,
    SimpleDataTable,
    DataCell,
    Icon,
    Text,
    Buttons,
    Page,
    PageHeader,
  } from "@gl/design-system";
  import { _, user } from "../../stores/index";
  import { navigate } from "svelte-routing";
  import { onMount } from "svelte";
  import { ContractsRepository } from "../../repositories";
  import {
    faPen,
    faPlus,
    faTrashAlt,
  } from "@fortawesome/pro-regular-svg-icons";
  import { ConfirmModal, ContractModal } from "../../components/index";
  import Layout from "../../components/Layout.svelte";
  import { format } from "date-fns";
  import {
    parseUrl,
    setModalParams,
    clearModalParams,
  } from "../../utils/index";
  let loading = {};

  let contracts = [];

  let modal;
  let confirmModal;
  let selectedCon;

  async function fetchContracts() {
    loading.contracts = true;
    try {
      const result = await ContractsRepository.getContracts();
      contracts = result.list;
    } finally {
      loading.contracts = false;
    }
  }

  async function handleDelete() {
    loading.delete = true;
    try {
      await ContractsRepository.deleteContract(selectedCon.id);
    } finally {
      fetchContracts();
      loading.delete = false;
    }
  }

  function openModal(contract = null) {
    modal = true;
    selectedCon = contract;
    setModalParams("contractModal", "contractId", {
      type: "true",
      id: contract?.id,
    });
  }

  function closeModal() {
    modal = false;
    selectedCon = null;
    clearModalParams("contractModal", "contractId");
  }

  onMount(async () => {
    if (!$user.data.isMaster) {
      navigate("/forbidden");
      return;
    }

    await fetchContracts();

    const query = parseUrl(window.location.search);
    if (query.contractModal) {
      if (query.contractId)
        selectedCon = contracts.find((c) => c.id === query.contractId);
      openModal(selectedCon);
    }
  });
</script>

{#if modal}
  <ContractModal
    {selectedCon}
    bind:active={modal}
    on:close={closeModal}
    on:success={() => {
      fetchContracts();
      closeModal();
    }}
  />
{/if}

{#if confirmModal}
  <ConfirmModal
    bind:active={confirmModal}
    on:close={() => {
      confirmModal = false;
      selectedCon = null;
    }}
    handleYes={handleDelete}
    title={$_("delete.resource", {
      values: { resourceType: $_("common.contract") },
    })}
    confirmationValue={selectedCon.id}
  >
    <p>
      {@html $_("delete.warning.access2", {
        values: {
          resourceName: `${selectedCon?.name} `,
        },
      })}
    </p>

    <p class="mt-4 mb-2">
      {@html $_("delete.confirmation", {
        values: {
          resourceType: $_("common.contract").toLowerCase(),
          resourceId: selectedCon?.id,
        },
      })}
    </p>
  </ConfirmModal>
{/if}

<Layout selected="contracts">
  <Page
    title={`${$_("admin.title")} | ${$_("common.contracts")} | ${$_("access-manager")}`}
  >
    <svelte:fragment slot="header">
      <PageHeader heading={$_("common.contracts")}>
        <Button slot="actions" on:click={() => openModal()}>
          <Icon icon={faPlus} />
          <Text>{$_("contracts.add")}</Text>
        </Button>
      </PageHeader>
    </svelte:fragment>

    <SimpleDataTable
      let:index
      let:row
      data={contracts}
      fullWidth
      selectable={false}
      variant="separate"
      loading={loading.contracts}
      stickyHead
    >
      <DataCell {index} id={`${row.id}-id`} header="ID">
        {row.id}
      </DataCell>

      <DataCell {index} header={$_("common.name")} id={`${row.id}-name`}>
        {row.name}
      </DataCell>

      <DataCell
        {index}
        header={$_("common.customer")}
        id={`${row.id}-customer`}
      >
        {row.customer.name}
      </DataCell>

      <DataCell
        {index}
        header={$_("common.authorizers")}
        id={`${row.id}-authorizers`}
      >
        {row.authorizers?.map((a) => a.name).join(", ") || "-"}
      </DataCell>

      <DataCell {index} header={$_("quota.role")}>
        {row.roleQuota ?? "∞"}
      </DataCell>

      <DataCell {index} header={$_("quota.group")}>
        {row.groupQuota ?? "∞"}
      </DataCell>
      <DataCell {index} header={$_("quota.user")}>
        {row.userQuota ?? "∞"}
      </DataCell>

      <DataCell {index} header={$_("common.created")}>
        {row.metadata?.createdAt
          ? format(new Date(row.metadata.createdAt), "dd.MM.yyyy")
          : "-"}
      </DataCell>

      <DataCell {index} header={$_("common.last.modified")}>
        {row.metadata?.modifiedAt
          ? format(new Date(row.metadata.modifiedAt), "dd.MM.yyyy HH:mm:ss")
          : "-"}
        {#if row.metadata?.modifiedBy}
          <p class="text-light" style="font-size:14px">
            {$_("common.by")}
            {row.metadata.modifiedBy}
          </p>
        {/if}
      </DataCell>

      <DataCell {index} header="">
        <Buttons>
          <Button size="tiny" on:click={() => openModal(row)}>
            <Icon icon={faPen} />
            <Text>{$_("buttons.edit")}</Text>
          </Button>

          <Button
            outlined
            size="tiny"
            status="error"
            on:click={() => {
              selectedCon = row;
              confirmModal = true;
            }}
          >
            <Icon icon={faTrashAlt} />
            <Text>{$_("buttons.delete")}</Text>
          </Button>
        </Buttons>
      </DataCell>
    </SimpleDataTable>
  </Page>
</Layout>
